import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { invalidateMemberProfile } from '@/lib/query-invalidation';

/**
 * Returns an `invalidate(memberId)` function that refreshes everything the
 * Member Profile screen shows for that member. See invalidateMemberProfile in
 * src/lib/query-invalidation.ts for what that covers.
 */
export function useInvalidateMemberProfile() {
  const queryClient = useQueryClient();

  return useCallback(
    (memberId: string) => {
      void invalidateMemberProfile(queryClient, memberId);
    },
    [queryClient],
  );
}
